import { render } from "./ProgrammsSlick.vue?vue&type=template&id=6008a496"
import script from "./ProgrammsSlick.vue?vue&type=script&lang=js"
export * from "./ProgrammsSlick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/ProgrammsSlick.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6008a496"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6008a496', __exports__)) {
    api.reload('6008a496', __exports__)
  }
  
  module.hot.accept("./ProgrammsSlick.vue?vue&type=template&id=6008a496", () => {
    api.rerender('6008a496', render)
  })

}


export default __exports__